import { RefObject } from "react"

export const openPartslifeInNewWindow = (url: string, contentRef?: RefObject<HTMLDivElement>) => {
    const navigationDom = document?.querySelector(".master")

    if (!contentRef?.current || !navigationDom) {
        return
    }

    const screenWidth = window.screen.availWidth
    const screenHeight = window.screen.availHeight

    const options = [
        `width=${screenWidth}`,
        `height=${screenHeight}`,
        "left=0",
        "top=0",
        "location=0",
        "resizable=1",
        "scrollbars=1",
        "status=yes",
        "noopener",
        "noreferrer",
    ].join(",")

    window.open(url, "_blank", options)
}
